import { createSelector } from '@ngrx/store';

const selectPsyTestingState = (state: any) => state.psyTesting;

export const selectPsyTestResult = createSelector(
  selectPsyTestingState,
  (state) => state.result
);

export const selectPsyTestLoading = createSelector(
  selectPsyTestingState,
  (state) => state.loading
);

export const selectPsyTestError = createSelector(
  selectPsyTestingState,
  (state) => state.error
);

export const selectSavePsyTestAnswersResult = createSelector(
  selectPsyTestingState,
  (state) => state.result
);

export const selectSavePsyTestAnswersError = createSelector(
  selectPsyTestingState,
  (state) => state.error
);

export const selectPsyTestReport = createSelector(
  selectPsyTestingState,
  (state) => state.report
);

export const selectPsyTestReportLoading = createSelector(
  selectPsyTestingState,
  (state) => state.loading
);

export const selectPsyTestReportError = createSelector(
  selectPsyTestingState,
  (state) => state.reportError
);
